export default __webpack_public_path__ + "static/media/cards-trade.01706428.png";